module.exports = __webpack_public_path__ + "img/menu_white.e50785c2.svg";